import { render, staticRenderFns } from "./MoneyStrategy.vue?vue&type=template&id=aa81f602&scoped=true"
import script from "./MoneyStrategy.vue?vue&type=script&lang=js"
export * from "./MoneyStrategy.vue?vue&type=script&lang=js"
import style0 from "./MoneyStrategy.vue?vue&type=style&index=0&id=aa81f602&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa81f602",
  null
  
)

export default component.exports